import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;


export const fetchEmpresaData = async (id) => {
    try { 
        const response = await axios.get(`${API_URL}/api/empresa/${id}`, {
            headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEmpresasData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/empresas`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

/**
 * Solo id y razon social, para el desplegable de «Empresa contratante».
 *
 * NO se usa `fetchEmpresasData`: aquella ruta esta acotada por rol y **deja fuera a `general`**, que
 * si puede crear y editar personas. Con ella, un `general` veria el selector vacio en un campo
 * obligatorio y no podria dar de alta a nadie.
 */
export const fetchEmpresasContratantesData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/empresas-contratantes`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        console.error('Error al obtener las empresas contratantes:', error);
        return [];
    }
}

export const fetchEmpresasFiltersData = async (paginaActual, registrosPorPag, busqueda, ordenarColumna, orden) => {
    try {
        const response = await axios.post(`${API_URL}/api/empresas/filters`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }
        }, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearEmpresa = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/empresa/add`, formData, {
            headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarEmpresa = async (empresaData) => {
    try {
        const response = await axios.put(`${API_URL}/api/empresa/update/${empresaData.Id}`, empresaData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEliminarEmpresa = async (ids) => {
    try {
        const idsArray = ids.toString().split(',');
        const promises = idsArray.map(id => axios.delete(`${API_URL}/api/empresa/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        }));
        const responses = await Promise.all(promises);
        const response = { data: responses.map(res => res.data) };
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchDepartamentosData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/departamentos`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Cache-Control': 'no-cache'
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};